import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Drink } from 'src/interfaces/drink.model';
import { Locale } from 'src/interfaces/locale.model';

@Component({
    selector: 'app-menu-recomendation-drink-variants',
    templateUrl: './menu-recomendation-drink-variants.component.html',
    styleUrls: ['./menu-recomendation-drink-variants.component.css'],
    standalone: false
})

export class MenuRecomendationDrinkVariantsComponent {
  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
  ) {
    this.choise = this.drink?.choise || 0;
    this.locale = this.dataService.locale;
  }

  @Input() drink : Drink | null = null;
  @Output() variantsRecomendationChange = new EventEmitter(); // Output property

  choise: number;
  locale: Locale | null = null;

  onRecomendationChoiseClick(): void {
    if (this.drink) {
      console.log('MenuRecomendationDrinkVariants | onRecomendationChoiseClick() | index:', this.choise);
      this.drink.choise = this.choise;
      this.variantsRecomendationChange.emit(); // Emit updated modificators
    }
  }

  ngAfterViewInit() {
    if (this.drink) this.choise = this.drink.choise;
    this.cdr.detectChanges();
  }
}
